import React from "react"

export default function Radio(props) {
  const { title } = props
  switch(title) {
    case '':
      return ( 
        <label class="radioRow">
          <input type="radio" id={props.id} name={props.name} value={props.value} hidden/>
          <div className="radio" />
        </label> 
      )
    default:
      return (
        <label class="radioRow">
          <input type="radio" id={props.id} name={props.name} value={props.value} hidden/>
          <div className="radio" />

          <span class="radioTitle">{props.title}</span>
        </label> 
      )
  }
}
